import { useNavigate } from 'react-router-dom'
import { CaretRight } from '@phosphor-icons/react'

const Breadcrumbs = ({ className = '', breadcrumbs = [] }) => {
  const navigate = useNavigate()
  if (breadcrumbs.length === 0) {
    return null
  }
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {breadcrumbs.map((breadcrumb, index) => (
        <div className='flex items-center space-x-2' key={index}>
          <span
            className={`${breadcrumb.to ? 'cursor-pointer text-gray-500' : 'font-semibold'}`}
            onClick={() => navigate(breadcrumb.to)}
          >
            {breadcrumb.text}
          </span>
          {index !== breadcrumbs.length - 1 ? <CaretRight size={16} aria-hidden /> : null}
        </div>
      ))}
    </div>
  )
}

export default Breadcrumbs
